<template>
  <div class="main-banner print-banner">
    <div class="row white-box mb20">
      <div class="banner-printbox">
        <img src="../assets/img/printbox.png">
        <p>神奇印箱，完美印象</p>
      </div>
    </div>
    <div class="row white-box">
      <div class="banner-download">
        <i class="icon-mobile-black fl"></i>
        <div class="download-tip">
          <span>印箱云打印APP客户端</span><br>
          <span>随时随印 移动办公</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "MainRight"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MainRight.vue